/* AG Admin. Access (manage-access UI, superadmin only).
   Lists the people who can use the admin, lets a superadmin add someone by
   email, tick which sections they get, change role, and remove them. Talks to
   the ag-admin-auth Worker's /admin/* endpoints with the caller's session
   token (superadmin-gated server-side too). */
(function () {
  const cfg = window.AG_ADMIN_CONFIG || {};
  const authUrl = String(cfg.authUrl || '').replace(/\/+$/, '');
  const $ = (s, r) => (r || document).querySelector(s);

  // Friendly labels for the section keys.
  const LABELS = {
    stock: 'Stock', analytics: 'Costs & Analytics', bundles: 'Bundle Builder',
    'discount-codes': 'Discount Codes', shipping: 'Shipping', library: 'Library',
    plans: 'Training Hall', ops: 'Ops', cs: 'Customer Service',
    'seo-studio': 'SEO Studio', 'post-editor': 'Post Editor',
  };
  const label = (s) => LABELS[s] || s;

  // Sections whose tool has its OWN sign-in and is NOT gated by this system, so
  // ticking them here is informational only. Only Ops (runs its own OTP board,
  // shell is no_gate). Customer Service IS gated + proxied by this system now.
  const EXTERNAL = { ops: 1 };

  function session() { try { return (window.AG_ADMIN && AG_ADMIN.session && AG_ADMIN.session()) || null; } catch (_) { return null; } }
  function toast(m, e) { try { window.AG_ADMIN && AG_ADMIN.toast && AG_ADMIN.toast(m, e); } catch (_) {} }

  async function adminApi(path, body, method) {
    const s = session();
    const token = s && s.token;
    const res = await fetch(authUrl + path, {
      method: method || 'POST',
      headers: Object.assign({ 'Content-Type': 'application/json' }, token ? { 'Authorization': 'Bearer ' + token } : {}),
      body: method === 'GET' ? undefined : JSON.stringify(body || {}),
    });
    let data = {}; try { data = await res.json(); } catch (_) {}
    if (!res.ok || (data && data.error)) { const e = new Error((data && data.error) || ('HTTP ' + res.status)); e.status = res.status; throw e; }
    return data;
  }

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const fmtDate = (ts) => { if (!ts) return 'never'; try { return new Date(ts * 1000).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: '2-digit' }); } catch (_) { return '-'; } };

  let SECTIONS = [];

  function sectionChecks(selected, idPrefix) {
    const set = new Set(selected || []);
    const hasExt = SECTIONS.some((s) => EXTERNAL[s]);
    return '<div class="agac-sections">' + SECTIONS.map((s) =>
      `<label class="agac-chk"><input type="checkbox" value="${s}"${set.has(s) ? ' checked' : ''}> ${esc(label(s))}` +
      (EXTERNAL[s] ? ' <span class="ag-muted">(own login)</span>' : '') + '</label>'
    ).join('') + '</div>' +
    (hasExt ? '<p class="ag-muted agac-foot">Ops has its own sign-in, so ticking it here is informational only.</p>' : '');
  }

  function renderShell(root) {
    root.innerHTML =
      '<div class="ag-admin-main">' +
        '<div class="ag-hub-head"><div>' +
          '<p class="eyebrow">Access control</p><h1>Manage access</h1>' +
          '<p class="sub">Who can use the admin, and which sections they can reach. Changes take effect within a minute.</p>' +
        '</div></div>' +
        '<div id="agac-msg"></div>' +
        '<section id="agac-add" class="agac-card" hidden>' +
          '<h2 class="ag-h2">Add a person</h2>' +
          '<div class="agac-addgrid">' +
            '<input id="agac-email" class="ag-input" type="email" placeholder="name@assassingoods.com">' +
            '<select id="agac-role" class="ag-select"><option value="member">Member</option><option value="superadmin">Superadmin (full + manage access)</option></select>' +
            '<button id="agac-add-btn" class="ag-btn">Add person</button>' +
          '</div>' +
          '<div id="agac-add-sections"><div class="agac-lbl">Sections they can use</div>' + sectionChecks([], 'add') + '</div>' +
        '</section>' +
        '<section id="agac-list"><h2 class="ag-h2">People</h2><div id="agac-users"><div class="ag-empty">Loading…</div></div></section>' +
      '</div>';
  }

  function renderUsers(users) {
    const wrap = $('#agac-users');
    if (!users.length) { wrap.innerHTML = '<div class="ag-empty">No one yet. Add the first person above.</div>'; return; }
    wrap.innerHTML = '<table class="ag-table agac-table"><thead><tr>' +
      '<th>Email</th><th>Role</th><th>Sections</th><th>Last login</th><th></th></tr></thead><tbody>' +
      users.map((u) => {
        const sup = u.role === 'superadmin';
        return '<tr data-email="' + esc(u.email) + '"' + (u.active ? '' : ' class="agac-inactive"') + '>' +
          '<td class="agac-email">' + esc(u.email) + (u.active ? '' : ' <span class="ag-pill mute">disabled</span>') + '</td>' +
          '<td><select class="ag-select agac-role"><option value="member"' + (sup ? '' : ' selected') + '>Member</option><option value="superadmin"' + (sup ? ' selected' : '') + '>Superadmin</option></select></td>' +
          '<td class="agac-secs">' + (sup ? '<span class="ag-muted">All sections</span>' : sectionChecks(u.sections, u.email)) + '</td>' +
          '<td class="ag-muted">' + fmtDate(u.last_login_at) + '</td>' +
          '<td class="agac-actions"><button class="ag-btn agac-save">Save</button> <button class="ag-btn secondary agac-remove">Remove</button></td>' +
          '</tr>';
      }).join('') + '</tbody></table>';
    // superadmin role hides the section checkboxes (they get all)
    wrap.querySelectorAll('tr[data-email]').forEach((tr) => {
      const roleSel = tr.querySelector('.agac-role');
      roleSel.addEventListener('change', () => {
        const secs = tr.querySelector('.agac-secs');
        secs.innerHTML = roleSel.value === 'superadmin' ? '<span class="ag-muted">All sections</span>' : sectionChecks([], tr.getAttribute('data-email'));
      });
    });
  }

  function collectSections(container) {
    return Array.prototype.map.call(container.querySelectorAll('input[type="checkbox"]:checked'), (c) => c.value);
  }

  async function load() {
    const msg = $('#agac-msg');
    try {
      const data = await adminApi('/admin/users', null, 'GET');
      SECTIONS = data.sections || [];
      $('#agac-add').hidden = false;
      // re-render the add-form section checks now that we have SECTIONS
      $('#agac-add-sections').innerHTML = '<div class="agac-lbl">Sections they can use</div>' + sectionChecks([], 'add');
      renderUsers(data.users || []);
      msg.innerHTML = '';
    } catch (e) {
      if (e.status === 403) msg.innerHTML = '<div class="ag-issues">Only a <b>superadmin</b> can manage access.</div>';
      else if (e.status === 401) msg.innerHTML = '<div class="ag-issues">Please sign in with your <b>email + code</b> to manage access (the shared password can’t manage users).</div>';
      else msg.innerHTML = '<div class="ag-issues">Couldn’t load: ' + esc(e.message) + '</div>';
      $('#agac-add').hidden = true;
      $('#agac-users').innerHTML = '';
    }
  }

  function wire(root) {
    root.addEventListener('click', async (ev) => {
      const t = ev.target;
      if (t.id === 'agac-add-btn') {
        const email = ($('#agac-email').value || '').trim().toLowerCase();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { toast('Enter a valid email', true); return; }
        const role = $('#agac-role').value;
        const sections = role === 'superadmin' ? [] : collectSections($('#agac-add-sections'));
        t.disabled = true;
        try { await adminApi('/admin/users/save', { email, role, sections, active: true }); toast('Added ' + email); $('#agac-email').value = ''; await load(); }
        catch (e) { toast('Failed: ' + e.message, true); } finally { t.disabled = false; }
        return;
      }
      const tr = t.closest && t.closest('tr[data-email]');
      if (!tr) return;
      const email = tr.getAttribute('data-email');
      if (t.classList.contains('agac-save')) {
        const role = tr.querySelector('.agac-role').value;
        const sections = role === 'superadmin' ? [] : collectSections(tr.querySelector('.agac-secs'));
        t.disabled = true;
        try { await adminApi('/admin/users/save', { email, role, sections, active: true }); toast('Saved ' + email); }
        catch (e) { toast('Failed: ' + e.message, true); } finally { t.disabled = false; }
      } else if (t.classList.contains('agac-remove')) {
        if (!window.confirm('Remove ' + email + '? They lose access immediately.')) return;
        t.disabled = true;
        try { await adminApi('/admin/users/remove', { email }); toast('Removed ' + email); await load(); }
        catch (e) { toast('Failed: ' + e.message, true); t.disabled = false; }
      }
    });
  }

  function boot() {
    const root = $('#ag-access-root');
    if (!root) return;
    renderShell(root);
    wire(root);
    load();
  }
  if (window.AG_ADMIN && AG_ADMIN.onReady) AG_ADMIN.onReady(boot);
  else document.addEventListener('DOMContentLoaded', boot);
})();
